// extracted by mini-css-extract-plugin
export default {"gameModal":"GameModal_gameModal__3ABdH","closeBtn":"GameModal_closeBtn__OGQvj"};